import controller from './thing-location.controller';

const template = require('./thing-location.html');

export default {
    bindings: {
        thingId: '<',
        location: '<',
        onUpdate: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/thing-location/thing-location.component.js